<template>
  <div class="instructor-role-item__wrapper">
    <template>
      <div
        class="role-item view"
        :class="{active: isActive}"
      >
        <img
          v-if="isActive"
          class="active-icon"
          src="/image/icon/active_role.svg"
        >
        <img
          v-else
          class="inactive-icon"
          src="/image/icon/inactive_role.svg"
        >
        <span>{{ form.name }}</span>
        <!-- <div
          v-if="isActive"
          class="role-item-control"
        >
          <button
            class="cancel"
            @click.stop="handleClickEdit"
          >
            수정
          </button>
          <button
            class="confirm"
            @click="handleClickDelete"
          >
            삭제
          </button>
        </div> -->
      </div>
    </template>
    <!-- <template v-if="mode === INLINE_FORM_MODE.FORM">
      <div class="role-item form">
        <img
          class="folder-icon"
          src="/image/folder/ing.png"
        >
        <input
          ref="inputroleName"
          v-model="form.name"
          type="text"
          placeholder="카테고리명 입력"
        >
        <div class="role-item-control">
          <button
            class="cancel"
            style="margin-left: 0;"
            @click="handleClickCancelForm"
          >
            취소
          </button>
          <button
            class="confirm"
            @click="handleClickSaveForm"
          >
            확인
          </button>
        </div>
      </div>
    </template> -->
  </div>
</template>

<script>

export default {
  name: 'InstructorRoleRoleInlineForm',
  props: [
    'data', 'isActive',
  ],
  data() {
    return {
      form: {
        id: null,
        name: '',
      },
    };
  },
  created() {
    if (this.data) {
      this.form = this.data;
    }
  },
};
</script>

<style lang="scss">
.instructor-role-item__wrapper{
    .role-item{
        padding: 5px;
        span{
            margin: auto;
        }
    }
}
.role-item-control {
	flex: initial;

	button {
		background-color: transparent;
		font-size: 11px;
		padding: 0 1px;
		line-height: 20px;
		letter-spacing: -0.6px;
		color: #ffffff;
		border: 0;
		margin-left: 10px;

		&.edit {
			color: white;
		}

		&.delete {
			color: #4a4a4a;
		}

		&.cancel {
			color: #d3d3d3;
		}

		&.confirm {
			color: #4a4a4a;
		}

		&:hover {
			cursor: pointer;
			text-decoration: underline;
		}

		&:focus {
			outline: none;
		}
	}
}
</style>
